/**
 * Blog category filters for list pages.
 * Slugs must match WordPress category slugs.
 * EN: /blog, /en/blog – posts in "Blog Post (EN)"
 * FI: /blogi – posts in "Blog Post (FI)"
 *
 * Base category is used when "All" is selected.
 */

export const BLOG_BASE_CATEGORY_EN = 'blog';
export const BLOG_BASE_CATEGORY_FI = 'blogi';

/** Category for "Tutustu identiolaisiin" / "Meet our team" section (rekry/careers). */
export const MEET_IDENTIANS_CATEGORY_FI = 'tutustu-identiolaisiin';
export const MEET_IDENTIANS_CATEGORY_EN = 'meet-identians';

/** Alternate category slugs to try for EN blog when "blog" returns no posts (WP may use different slug). */
export const ALTERNATE_BLOG_CATEGORY_SLUGS_EN = ['blog', 'blog-post-en', 'blog-post'];

/** Slugs to hide from card display (parent "Blog Post" and "Meet Identians" etc.). */
export const HIDDEN_CATEGORY_SLUGS = [
  'blog',
  'blogi',
  'tutustu-identiolaisiin',
  'meet-identians',
];

export const BLOG_CATEGORIES_EN = [
  { slug: 'announcements', label: 'Announcements' },
  { slug: 'business', label: 'Business' },
  { slug: 'consulting', label: 'Consulting' },
  { slug: 'culture', label: 'Culture' },
  { slug: 'design', label: 'Design' },
  { slug: 'technology', label: 'Technology' },
];

export const BLOG_CATEGORIES_FI = [
  { slug: 'tiedotteet', label: 'Tiedotteet' },
  { slug: 'liiketoiminta', label: 'Liiketoiminta' },
  { slug: 'konsultointi', label: 'Konsultointi' },
  { slug: 'kulttuuri', label: 'Kulttuuri' },
  { slug: 'teknologia', label: 'Teknologia' },
];

export function getCategoriesForLang(lang) {
  return lang === 'fi' ? BLOG_CATEGORIES_FI : BLOG_CATEGORIES_EN;
}

export function getBaseCategoryForLang(lang) {
  return lang === 'fi' ? BLOG_BASE_CATEGORY_FI : BLOG_BASE_CATEGORY_EN;
}

/** Returns categories suitable for card display, excluding Blog Post (EN/FI). */
export function getDisplayCategories(categories) {
  if (!categories?.length) return [];
  return categories.filter(
    (c) => c?.slug && !HIDDEN_CATEGORY_SLUGS.includes(c.slug),
  );
}
